module.exports = __webpack_public_path__ + "static/media/elderly-woman-white-hair.6eff9c5c.svg";